<div>
  <img src="assets/imgs/toast/warning.svg" alt="Warning Message Icon" />
  <h4>{{ title }}</h4>
  <p>{{ message }}</p>
</div>
